console.log('projects');

import { script } from '@base_js/script'

// Styles
import '@root/fonts/icomoon/style.css'
import '@custom_vendors/flickity/flickity.min.css'
import '@root/less/base.less'
import '@root/less/end.less'
import '@root/less/projects.less'

script()

jQuery(function($)
{
    var w = $(window);
    $('.js-animate-bg-color').each(function()
    {
        var box = $(this),
            classes = ['c1', 'c2', 'c3', 'c4'], uniqueRandoms = [],
            current = null, currentClass = null,
            makeUniqueRandom = function()
            {
                if (!uniqueRandoms.length) for (var i = 0; i < classes.length; i++) uniqueRandoms.push(i);
                var index = Math.floor(Math.random() * uniqueRandoms.length);
                var val = uniqueRandoms[index];
                uniqueRandoms.splice(index, 1);
                return val;
            },
            changeClass = function()
            {
                if (currentClass) box.removeClass(currentClass);
                current = makeUniqueRandom();
                currentClass = classes[current];
                box.addClass(currentClass);
            };

        changeClass();
        setTimeout(function()
        {
            box.addClass('bg-anim');
            setInterval(changeClass, 5000);
        }, 10);
    });

    $('.js-responsive-bg-image').each(function()
    {
        var box = $(this),
            last = false,
            ww = 0,
            changeImage = function()
            {
                ww = w.width();
                if (ww <= 320 && last !== 320)
                {
                    box.css('background-image', 'url(' + box.data('bg320') + ')');
                    last = 320;
                }
                else if (ww > 320 && ww <= 375 && last !== 375)
                {
                    box.css('background-image', 'url(' + box.data('bg375') + ')');
                    last = 375;
                }
                else if (ww > 375 && ww <= 480 && last !== 480)
                {
                    box.css('background-image', 'url(' + box.data('bg480') + ')');
                    last = 480;
                }
                else if (ww > 480 && ww <= 768 && last !== 768)
                {
                    box.css('background-image', 'url(' + box.data('bg768') + ')');
                    last = 768;
                }
                else if (ww > 768 && ww <= 992 && last !== 992)
                {
                    box.css('background-image', 'url(' + box.data('bg992') + ')');
                    last = 992;
                }
                else if (ww > 992 && last !== 1920)
                {
                    box.css('background-image', 'url(' + box.data('bg1920') + ')');
                    last = 1920;
                }
            };

        changeImage();
        w.on('resize', changeImage);
    });

    $('.filter-link').each(function()
    {
        var link = $(this),
            cls = link.attr('href').substr(1);

        link.magnificPopup(
        {
            type:'inline',
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in ' + cls,
            midClick: true,
            closeMarkup: '<button type="button" class="mfp-close icon icon-close-l"></button>',
            callbacks:
            {
                beforeOpen: function ()
                {
                    if (link.data('hide')) link.addClass('filter-link-hidden');
                },
                beforeClose: function ()
                {
                    if (link.data('hide')) link.removeClass('filter-link-hidden');
                }
            }
        });
    })
});